/**
 * Inline MSW responses for the public API rate limit endpoints (company Integrations → Rate Limits).
 * Spread into INLINE_RESPONSES in inlineResponses.tsx.
 */
export const COMPANY_API_RATE_LIMITS_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // Enforcement off, which is the default and the state an operator meets first: usage is being
  // counted so a limit can be sized, but nothing is refused yet. One row of each kind, so every
  // badge and both row actions render.
  "/apollo/company-api-rate-limits/list": {
    enforcementEnabled: false,
    limits: [
      {
        endpoint: "/v1/saved-commodities/create",
        requestsPerHour: 500,
        isOverride: false,
        defaultRequestsPerHour: 500,
        usedInLastHour: 12,
        updatedByEmail: undefined,
        updatedAt: undefined,
      },
      {
        endpoint: "/v1/saved-commodities/update",
        requestsPerHour: 500,
        isOverride: false,
        defaultRequestsPerHour: 500,
        usedInLastHour: 0,
        updatedByEmail: undefined,
        updatedAt: undefined,
      },
      {
        endpoint: "/v1/shipments/get-shipment",
        requestsPerHour: 5000,
        isOverride: true,
        defaultRequestsPerHour: 1000,
        usedInLastHour: 3184,
        updatedByEmail: "operations@freightsimple.com",
        updatedAt: "2026-08-28T16:40:00Z",
      },
      {
        endpoint: "/v1/shipments/start-booking",
        requestsPerHour: 50,
        isOverride: true,
        defaultRequestsPerHour: 100,
        usedInLastHour: 3,
        updatedByEmail: "operations@freightsimple.com",
        updatedAt: "2026-09-01T09:05:00Z",
      },
      {
        endpoint: "/v1/shipments/start-quoting",
        requestsPerHour: 100,
        isOverride: false,
        defaultRequestsPerHour: 100,
        usedInLastHour: 7,
        updatedByEmail: undefined,
        updatedAt: undefined,
      },
    ],
  },
};
